import { IdentitySettingsListItem } from '../../../integrated-client/models/';

export class ResultsData {

  items: Array<IdentitySettingsListItem>
  showMore: boolean

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}
